import { Subject } from 'rxjs';

/**
 * One "a line was added to the cart" event for both item popups: the options
 * modal (`RecipeOptionModalService.addedToCart$`) and the legacy extras popup
 * (`popupService.addedToCartSuccessful`) both point at this Subject, so every
 * listener hears an add whichever popup made it — the legacy menu's own cart
 * refreshes when the new card's modal adds an item, and the shop / search /
 * checkouts refresh when the legacy popup does.
 *
 * A plain Subject on purpose: a listener that subscribes later must not get a
 * replay of the previous add.
 */
export const addedToCartEvents = new Subject<any>();
